import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccessService } from 'app/core/services/access.service';

@Component({
  selector: 'dialog-add-access',
  templateUrl: './dialog-add-access.component.html',
  styleUrls: ['./dialog-add-access.component.scss']
})
export class DialogAddAccessComponent implements OnInit {

  isLoading: boolean = false;
  accessGroup: FormGroup;
  user: any[] = [];
  filteredUsers: any[] = [];

  selectedUser: any;
  userSearchText: string = '';

  constructor(public dialogRef: MatDialogRef<DialogAddAccessComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private accessService: AccessService) {
    this.accessGroup = this.fb.group({
      id: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    if (this.data.type === 'client-employee') {
      this.getAvailableClientEmployees();
    } else {
      this.getAvailableAdmins();
    }
  }

  getAvailableAdmins() {
    this.accessService.getAvailableAdmins().subscribe({
      next: res => {
        this.user = res;
        this.filteredUsers = [...res];
      },
      error: err => {
        console.log(err);
      }
    })
  }

  getAvailableClientEmployees() {
    this.accessService.getAvailableClientEmployees().subscribe({
      next: res => {
        this.user = res;
        this.filteredUsers = [...res];
      },
      error: err => {
        console.log(err);
      }
    })
  }

  filterUsers() {
    const searchText = this.userSearchText.toLowerCase();
    this.filteredUsers = this.user.filter(u =>
      u.name.toLowerCase().includes(searchText)
    );
  }

  onUserChange(event: any) {
    const userId = event.value;
    if (userId) {
      this.accessGroup.patchValue({ id: userId });
    }
  }

  onDropdownOpenChange(event: boolean) {
    if (event) {
      this.userSearchText = '';
      this.filteredUsers = [...this.user];
    }
  }

  getUserName(userId: any): string {
    const user = this.user.find(u => u.id === userId);
    return user ? user.name : '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit() {
    this.isLoading = true;
    this.accessService.insertAdmin(this.accessGroup.value.id).subscribe({
      next: res => {
        this.isLoading = false;
        this.dialogRef.close(res);
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }

  submitSupervisor() {
    this.isLoading = true;
    this.accessService.insertSupervisor(this.accessGroup.value.id).subscribe({
      next: res => {
        this.isLoading = false;
        this.dialogRef.close(res);
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }

  submitClientEmployee() {
    this.isLoading = true;
    this.accessService.insertClientEmployee(this.accessGroup.value.id).subscribe({
      next: res => {
        this.isLoading = false;
        this.dialogRef.close(res);
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }
}